import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular';
import { SaleItem } from "../../model/SaleItem";
import { confirm } from 'devextreme/ui/dialog';
import { SessionContextService } from 'src/app/services/session-context.service';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { Discount } from '../../model/resource.model';

@Component({
  selector: 'app-sale-item-editor',
  templateUrl: './sale-item-editor.component.html',
  styleUrls: ['./sale-item-editor.component.css']
})
export class SaleItemEditorComponent implements OnInit {

  @Output() CloseDlg: EventEmitter<{ Action: string, saleItem: SaleItem }> = new EventEmitter<{ Action: string, saleItem: SaleItem }>();

  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  @ViewChild(DxFormComponent) form: DxFormComponent;

  public saleItemDetail: SaleItem = new SaleItem();
  tabPage: number = 0;
  originalPrice: number = 0;
  DisableResetPrice: boolean = true;
  discountList:Discount[] = [];

  ItemOriginalPriceEditorOptions= { format: '£#,##0.00',     
    readonly:true
  };

  ItemPriceEditorOptions = { min: 0, max: 999.99, format: '£#,##0.00', 
    showSpinButtons: true,
    onValueChanged: this.onPriceChanged.bind(this), 
    width:200 
  };

  ItemQtyEditorOptions = { min: 1, max: 999, showSpinButtons: true, width:200 };

  DiscountEditorOptions = {
    items: this.session.defaultData.defData.Discounts.filter(i => i.Active==true), 
    displayExpr: 'Description', 
    valueExpr: 'Id', 
    onValueChanged: this.onDiscountCodeChanged.bind(this), 
    width:300,
    showClearButton: true, 
    searchEnabled: true, 
    searchExpr: ['Description'], 
    searchMode: 'contains', 
    placeholder: 'Select Discount'
  };

  constructor(private session: SessionContextService) {
    this.show = this.show.bind(this);
    this.onShowing = this.onShowing.bind(this);
    this.onHiding = this.onHiding.bind(this);
    this.btnEdit = this.btnEdit.bind(this);
    this.btnResetPrice = this.btnResetPrice.bind(this);
    this.btnDeleteItem = this.btnDeleteItem.bind(this);
    this.onDiscountCodeChanged = this.onDiscountCodeChanged.bind(this);
    this.discountList = this.session.defaultData.defData.Discounts.filter(i => i.Active==true);
  }

  ngOnInit(): void {
  }

  onShowing(e) {
  }

  onHiding(e) {
  }

  onPriceChanged(e) {
    this.saleItemDetail.StaffUpdatedPrice = true;
    
    // if we have manually adjusted the price then discount is no longer applicable, set to zero
    this.saleItemDetail.Discount = 0;
    this.saleItemDetail.DiscountCode = -1;

    this.update();
  }
  
  onDiscountCodeChanged(e)
  {
    var d = this.discountList.find(i => i.Id == e.value);
    if (d)
    {
      this.saleItemDetail.Discount = (this.GetOriginalPrice() * d.DiscountPercentage / 100);
      this.saleItemDetail.Price = this.GetOriginalPrice() - this.saleItemDetail.Discount;      
      this.saleItemDetail.StaffUpdatedPrice = true;
      this.saleItemDetail.DiscountCode = d.Id;
      this.update();
    }
  }

  public show(SelectedSaleItem: SaleItem) {
    this.popup.visible = true;
    this.saleItemDetail = SaleItem.CreateFrom(SelectedSaleItem); // Shallow copy of object - No functions copied    
    this.originalPrice = this.GetOriginalPrice();  // this.saleItemDetail.Price;
    this.update();
  }

  update() {
    this.DisableResetPrice = (this.saleItemDetail.Price != this.GetOriginalPrice());    
    this.form.instance._refresh();
  }

  btnEdit(e) {
    this.tabPage = 0;
  }

  btnResetPrice(e) {
    confirm("Are you sure you want to reset the item's price?", "Reset Price").then(rc => {
      if (rc == true) {
        // Get Product Price from this.saleItemDetail.ProductId
        this.saleItemDetail.Price = this.GetOriginalPrice();
        this.saleItemDetail.StaffUpdatedPrice = false;
        this.form.instance._refresh();
      }
    });
  }

  private GetOriginalPrice() {
    var origPrice: number = 0;
    switch (this.saleItemDetail.SaleItemType) {
      case 1: origPrice = this.session.defaultData.defData.Products.find(i => i.ProductId == this.saleItemDetail.ProductId)?.Price;
        break;
      case 2: origPrice = this.session.defaultData.defData.Courses.find(i => i.CourseId == this.saleItemDetail.ProductId)?.Price;
        break;
      case 3:
        {
          if (this.saleItemDetail.FullPrice == 0)
            origPrice = this.session.defaultData.defData.Sessions.find(i => i.SessionId == this.saleItemDetail.ProductId)?.RetailPrice;
          else
            origPrice = this.saleItemDetail.FullPrice;
        }
        break;
      default: origPrice = this.originalPrice;
        break;
    }
    return origPrice;
  }

  btnDeleteItem(e) {
    confirm("Are you sure you want to delete this item from the basket?", "Delete Item").then(rc => {
      if (rc == true) {
        this.CloseEditor("DELETE");
      }
    });
  }

  btnUpdateItem(e) {
    this.CloseEditor("UPDATE");
  }

  btnCancel(e) {
    this.CloseEditor("CANCEL");
  }

  CloseEditor(action: string) {
    if (this.saleItemDetail.Qty == 0 && action == "UPDATE") {
      confirm("Are you sure you want to delete this item from the basket?", "Delete Item").then(rc => {
        if (rc == true) {
          this.CloseEditor("DELETE");
        }
      });
    }
    else {
      this.CloseDlg.emit({ Action: action, saleItem: this.saleItemDetail });
      this.popup.visible = false;
    }
  }
}